<script>
    export let projectSettings;
    export let projectUpdateSettings;

    import {saveSettings, loadSettings} from '../lib/local-storage';
    import Chip, { Set, Text } from '@smui/chips';
    import Snackbar, { Actions, Label } from '@smui/snackbar';
    import Button, { Icon as ButtonIcon } from '@smui/button';
    import Fab, { Icon } from '@smui/fab';
    import MenuSurface from '@smui/menu-surface';
    import Textfield from '@smui/textfield';

    let settings;
    let labels = [];
    let labelExists = false;
    let surface;
    let newLabelName = '';
    let selectedLabel;
    let selectedLabelId;
    let labelIds = []

    const update = () => {
        settings = loadSettings();
        labels = [...settings.labels];
        labelIds = labels.map(label => label.labelId + '');
        selectedLabel = settings.selectedLabel + '';
    }

    const saveLocalSettings = () => {
        saveSettings(settings)

        if(typeof projectUpdateSettings === 'function') {
            projectUpdateSettings();
        }
    }

    const getHighestLabelId = () => {
        let highestId = 0;
        labels.forEach(label => {
            if (label.labelId > highestId) {
                highestId = label.labelId;
            }
        });
        return highestId;
    };
    
    const addLabel = () => {
        
        const exists = labels.filter((label) => label.name === newLabelName)
        if(exists.length) {
            labelExists.open();
            return;
        }

        labels = [...labels, {
            labelId: getHighestLabelId()+1,
            name: newLabelName
        }]
        settings.labels = labels;
        saveLocalSettings();
        surface.setOpen(false);
        newLabelName = '';
        update();
    }
    export function getSelectedLabel() {
        return selectedLabel;
    }
    const getLabelByLabelId = (labelId) => {
        return labels.find(e => e.labelId === labelId)
    }
    const getNameByLabelId = (labelId) => {
        return labels.find(e => e.labelId === labelId)['name']
    }

    const changeLabelSelection = (e) => {
        if(!selectedLabel) {
            selectedLabel = settings.selectedLabel + '';
            return;
        }
        settings = loadSettings();
        settings.selectedLabel = parseInt(selectedLabel);
        saveLocalSettings();
    }
    update()
    $: [
        //update(projectSettings)
    ]
</script>
<Snackbar bind:this={labelExists}>
    <Label>Nice Try! Label already exists.</Label>
</Snackbar>

{#if labels.length > 0}
    <div class="ge-row ge-label-selection">
        <div class="ge-noshrink">
            <Fab color="primary" class="ge-fab" on:click={() => surface.setOpen(true)} mini>
                <Icon class="material-icons">add</Icon>
            </Fab>
            <MenuSurface bind:this={surface} anchorCorner="BOTTOM_LEFT">
                <div style="margin: 1em; display: flex; flex-direction: column; align-items: flex-end;">
                    <Textfield bind:value={newLabelName} label="Label Name" />
                    <Button style="margin-top: 1em;" on:click={addLabel}>
                        Add Label
                    </Button>
                </div>
            </MenuSurface>
        </div>
        <Set chips={labelIds} let:chip choice bind:selected={selectedLabel} on:MDCChip:selection={(e) => changeLabelSelection(e)}>
            <Chip chip={chip}>
                <Text>{chip}: {getNameByLabelId(parseInt(chip))}</Text>
            </Chip>
        </Set>
    </div>
{/if}
<style>
    .ge-label-selection{
        
        align-items:flex-start;
    }
    :global(.ge-fab){
        margin: 8px;
        height: 32px;
        width: 32px;
    }
</style>